import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { CustomSwitch } from "components/common/Switch";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import ErrorMessage from "components/common/ErrorMessage";
import { setError } from "slices/typeSlice";
import { updateType } from "slices/typeSlice";
import { addType } from "slices/typeSlice";
import { typesSelector } from "slices/typeSlice";
import { Controller, FormProvider, useForm } from "react-hook-form";
import PhoneInput from "components/common/PhoneInput";
import { AsyncPaginate } from "react-select-async-paginate";
import { selectCustomStyles } from "components/common/Select";
import TagInput from "components/TagInput";
import { fetchStates } from "slices/stateSlice";
import { stateSelector } from "slices/stateSlice";
import { Select } from "components/common/Select";
import { IconButton, Switch } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import FullPageLoader from "components/common/FullPageLoader";
import CustomTiers from "./CustomTiers";
import LanguageTiers from "./LanguageTiers";
import FilterSwitch from "./FilterSwitch";
import { usePermissions } from "layouts/Admin";
import DynamicFacilities from "./DynamicFacilities";
import DynamicDepartments from "./DynamicDepartments";
import { fetchCountries } from "slices/countrySlice";
import { fetchTimezone } from "slices/timezoneSlice";
import { fetchPreferredLanguagesList } from "slices/languageSlice";
import { USA } from "constants/common";
import Swal from "sweetalert2";
import { fetchSingleType } from 'slices/typeSlice';
import { clearAllType } from "slices/typeSlice";
import { clearSingleTypes } from "slices/typeSlice";
import { fetchTemplates } from 'slices/templateSlice';
import TranslationTiersPreview from "./TranslationTiersPreview";
import CustomTranslationTiers from "./CustomTranslationTiers";
import ReactSelect from "react-select";
const AccountForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [clientTierId, setClientTierId] = useState([]);
  const { checkPermission } = usePermissions();
  const [lockStates, setLockStates] = useState({});
  const { state: states } = useSelector(stateSelector);
  const [allStates, setAllStates] = useState([]);
  const [languageState, setLanguageState] = useState(null);
  const { singleType : item, loader : loading } = useSelector(typesSelector);
  const { id } = useParams();
  const [deletedSubjects, setDeletedSubjects] = useState([]);
  // State add karo
  const [departmentMap, setDepartmentMap] = useState([]); 
  // [{id: 10, name: "dp 3"}, {id: 11, name: "dp 4"}, ...]

  const [subAccountMap, setSubAccountMap] = useState([]);
  const [pendingDepartmentEdit, setPendingDepartmentEdit] = useState(null);
  const [pendingSubAccountEdit, setPendingSubAccountEdit] = useState(null);

  const mapTagNamesToEntities = (
    newNames = [],
    previousEntities = [],
    pendingEditEntity = null
  ) => {
    const names = Array.isArray(newNames) ? newNames : [];
    const prevEntities = Array.isArray(previousEntities) ? previousEntities : [];
    const usedPrevIndexes = new Set();

    const mapped = names.map((name) => {
      const prevIndex = prevEntities.findIndex(
        (entity, index) => !usedPrevIndexes.has(index) && entity.name === name
      );
      if (prevIndex !== -1) {
        usedPrevIndexes.add(prevIndex);
        return prevEntities[prevIndex];
      }
      return null;
    });

    const missingOldIndexes = prevEntities
      .map((_, index) => (usedPrevIndexes.has(index) ? null : index))
      .filter((index) => index !== null);
    const missingNewIndexes = mapped
      .map((item, index) => (item === null ? index : null))
      .filter((index) => index !== null);

    if (pendingEditEntity && missingNewIndexes.length === 1) {
      mapped[missingNewIndexes[0]] = {
        id: pendingEditEntity.id ?? null,
        name: names[missingNewIndexes[0]],
      };
    } else if (missingOldIndexes.length === missingNewIndexes.length && missingOldIndexes.length > 0) {
      missingNewIndexes.forEach((newIndex, idx) => {
        const oldEntity = prevEntities[missingOldIndexes[idx]];
        mapped[newIndex] = {
          id: oldEntity?.id ?? null,
          name: names[newIndex],
        };
      });
    }

    return mapped.map((item, index) => item || { id: null, name: names[index] });
  };

  useEffect(() => {
    resetAllFields();

    return () => {
      resetAllFields();
    };
  }, []);


  
  useEffect(() => {
    // resetAllFields();
    if (id) {
        
      dispatch(fetchSingleType(id));
      dispatch(fetchTemplates({ page: 1, pageLength: 20, sortBy: "id", sortDirection: "asc"}, true, true));
    }
  }, [dispatch, id]);

  const [filterStates, setfilterStates] = useState({
    label: "",
    value: "",
  });

  const [filterCountries, setfilterCountries] = useState({
    label: "",
    value: "",
  });

  console.log("ClientItems", item);
  const interpretationRates = {
    opi_normal_rate: [],
    vri_normal_rate: [],
    inperson_normal_rate: [],
    opi_normal_rate_time_unit: [],
    vri_normal_rate_time_unit: [],
    inperson_normal_time_unit: [],
    opi_normal_mins: [],
    vri_normal_mins: [],
    inperson_normal_mins: [],
    opi_after_rate: [],
    vri_after_rate: [],
    inperson_after_rate: [],
    opi_after_rate_time_unit: [],
    vri_after_rate_time_unit: [],
    inperson_after_time_unit: [],
    opi_after_mins: [],
    vri_after_mins: [],
    inperson_after_mins: [],
  };
  // const handleClientData = (clientData) => {
  //   setValue("client_tier_id", clientData);
  // };
  const handleClientData = (tiers) => {
    if (!Array.isArray(tiers) || tiers.length === 0) return;

    const subjectIndex = tiers[0]?.subjectIndex;
    if (subjectIndex === undefined || subjectIndex === null) return;

    setValue(`interpretationRatesBySubject.${subjectIndex}`, tiers);
  };

  const handleRemoveSubject = (indexToRemove) => {
    // Get current values to perform manual shifting of the arrays
    const currentSubjects = watch("subjects") || [];
    const currentConfigs = watch("subjectConfigs") || [];
    const currentRates = watch("interpretationRatesBySubject") || [];
    const currentCustomTiers = watch("subjectCustomTiers") || [];
    
    // Track the subject being deleted
    const subjectBeingDeleted = currentSubjects[indexToRemove];
    if (subjectBeingDeleted) {
      setDeletedSubjects(prev => [...prev, subjectBeingDeleted?.value || subjectBeingDeleted]);
    }

    // Filter out the items at the targeted index
    const newSubjects = currentSubjects.filter((_, i) => i !== indexToRemove);
    const newConfigs = currentConfigs.filter((_, i) => i !== indexToRemove);
    const newRates = currentRates.filter((_, i) => i !== indexToRemove);
    const newCustomTiers = currentCustomTiers.filter((_, i) => i !== indexToRemove);

    // Update all relevant arrays in the form state
    // We update the entire arrays so that React Hook Form correctly shifts all subsequent values
    setValue("subjects", newSubjects, { shouldValidate: true });
    setValue("subjectConfigs", newConfigs, { shouldValidate: true });
    setValue("interpretationRatesBySubject", newRates, { shouldValidate: true });
    setValue("subjectCustomTiers", newCustomTiers, { shouldValidate: true });

    // Clean up the last index in the registry since the array length has decreased
    const lastIndex = currentSubjects.length - 1;
    unregister(`subjects.${lastIndex}`);
    unregister(`subjectConfigs.${lastIndex}`);
    unregister(`interpretationRatesBySubject.${lastIndex}`);
    unregister(`subjectCustomTiers.${lastIndex}`);

    // Finally, update the React state to render the correct number of blocks (0 to N-1)
    setSubjectBlocks(newSubjects.map((_, i) => i));
  };


  const [subjectBlocks, setSubjectBlocks] = useState([0]);
  const defaultSubjects = subjectBlocks.map(() => "");

  const methods = useForm({
    defaultValues: {
      interpretationRates,
      client_tier_id: [],
      subjects: [""],
      translation_template_id: "",
      selected_translation_rates: [],
      translationTemplateBlocks: [
        { id: 0, template_id: "", filterTemplate: null, rates: [] },
      ],
      customTranslationTiers: [],
    },
  });
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    control,
    setValue,
    clearErrors,
    resetField,
    unregister,
  } = methods;
  console.log(watch('interpretationRatesBySubject'), 'watch interpretationRatesBySubject');
  console.log(watch("subjectConfigs"), 'watch subjectConfigs');
  console.log(watch("subjectCustomTiers"), 'watch subjectCustomTiers');
  const { loader, error } = useSelector(typesSelector);
  const [status, setStatus] = useState(1);
  const [credentialsSend, setCredentialsSend] = useState(0);
  const [notification, setNotification] = useState(1);
  const [interpretation, setInterpretation] = useState(1);
  const [translation, setTranslation] = useState(1);
  const [requesterDetailsShowInvoice, setRequesterDetailsShowInvoice] = useState(1);
  const [interpreterNameShowInvoice, setInterpreterNameShowInvoice] = useState(1);
  const [noOfVariants, setNoOfVariants] = useState([
    {
      field: "",
      required: 0,
      show_in_invoice: true,
    },
  ]);
  console.log('translationssss',translation);
  console.log(watch('subjects'), 'subjects watchhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh');
  const invoiceOption = [
    {
      label: "Weekly",
      value: "weekly",
    },
    {
      label: "Bi-weekly",
      value: "bi-weekly",
    },
    {
      label: "Monthly",
      value: "monthly",
    }
  ];
  const [filterTimezones, setFilterTimezones] = useState({
    label: "",
    value: "",
  });
  const resetAllFields = () => {
    setValue("name", "");
    setValue("email", "");
    setValue("password", "");
    setValue("phone", "");
    setValue("us_based", false);
    setValue("non_us_based", false);
    setValue("english_to_target", false);
    setValue("spanish_to_target", false);
    setValue("medical_certified", false);
    setValue("court_certified", false);
    setValue("dynamic_fields", []);
    setStatus(1);
    clearErrors("english_to_target");
    setValue("facility_names", []);
    setValue("facilities", []);
    setValue("department_names", []);
    setValue("subaccount_names", []);
    setValue("subjects", [""]);
    setValue("item", [""]);
    setRequesterDetailsShowInvoice(1);
    setInterpreterNameShowInvoice(1);
    dispatch(clearSingleTypes([]));
    setLockStates(false);
    setValue("invoice_group_by", []);
  };

  console.log(watch("subjects"), 'subjects watchhhhh');
  useEffect(() => {
    setValue("name", item?.name || "");
    setValue("email", item?.email || "");
    setValue("password", "");
    setValue("phone", item?.phone || "");
    setValue(
      "facility_names",
      item?.facilities?.map((i) => i.abbreviation) || []
    );
    // setValue("department_names", item?.departments?.map((i) => i.name) || []);
    // setValue("subaccount_names", item?.sub_accounts?.map((i) => i.name) || []);
    setValue("departments", item?.departments?.map((i) => ({ id: i.id, name: i.name , billing_email: i.billing_email, contact_person_name : i.contact_person_name, is_communication_poc: i.is_communication_poc, poc_name: i.poc_name, poc_email: i.poc_email, poc_phone: i.poc_phone })) || []);
    setValue("sub_accounts", item?.sub_accounts?.map((i) => ({ id: i.id, name: i.name })) || []);

    setValue("us_based", item?.filters?.us_based == 1 ? true : false || false);
    setValue(
      "non_us_based",
      item?.filters?.non_us_based == 1 ? true : false || false
    );
    setValue(
      "english_to_target",
      item?.filters?.english_to_target == 1 ? true : false || false
    );
    setValue(
      "spanish_to_target",
      item?.filters?.spanish_to_target == 1 ? true : false || false
    );
    setValue(
      "medical_certified",
      item?.filters?.medical_certified == 1 ? true : false || false
    );
    setValue(
      "court_certified",
      item?.filters?.court_certified == 1 ? true : false || false
    );

    setValue(
      "us_based_locked",
      item?.filters?.us_based_locked == 1 ? true : false || false
    );
    setValue(
      "non_us_based_locked",
      item?.filters?.non_us_based_locked == 1 ? true : false || false
    );
    setValue(
      "english_to_target_locked",
      item?.filters?.english_to_target_locked == 1 ? true : false || false
    );
    setValue(
      "spanish_to_target_locked",
      item?.filters?.spanish_to_target_locked == 1 ? true : false || false
    );
    setValue(
      "medical_certified_locked",
      item?.filters?.medical_certified_locked == 1 ? true : false || false
    );
    setValue(
      "court_certified_locked",
      item?.filters?.court_certified_locked == 1 ? true : false || false
    );

    setValue("billing_email", item?.billing_email || "");
    setValue("billing_person", item?.billing_person || "");
    setValue("billing_zipcode", item?.billing_zipcode || "");
    setValue("billing_state_id", item?.billing_state?.id || "");
    setValue("billing_city_name", item?.billing_city_name || "");
    setValue("billing_phone", item?.billing_phone || "");
    setValue("timezone_id", item?.timezone_id || "");
    setValue("preferred_language_id", item?.preferred_language?.id || item?.preferred_language_id || "");
    setValue("notification_emails", item?.notification_emails || "");

    setValue(
      "invoice_group_by",
      Array.isArray(item?.invoice_group_by)
        ? item.invoice_group_by
        : (typeof item?.invoice_group_by === "string" && item.invoice_group_by.length > 0
            ? item.invoice_group_by.split(",").map((v) => v.trim())
            : [])
    );

    setValue("invoicing_period", item?.invoicing_period || item?.subclient_type_rates?.[0]?.invoicing_period || "");

    const temp_array = [];
    setValue(
      "dynamic_fields",
      item?.dynamic_fields?.map((p) => {
        temp_array.push({
          field: p?.name,
          id: p?.id,
          required: p?.required,
          show_in_invoice: typeof p?.show_in_invoice === "boolean" ? p.show_in_invoice : (p?.show_in_invoice ?? 1) ? true : false,
        });
        return p?.name;
      })
    );

    temp_array?.length > 0
      ? setNoOfVariants(temp_array)
      : setNoOfVariants([{ field: "", id: 1, required: 0, show_in_invoice: false }]);

    setValue(
      "spanish_translation_rate",
      item?.translation_rates?.spanish_translation_rate || ""
    );
    setValue(
      "other_translation_rate",
      item?.translation_rates?.other_translation_rate || ""
    );
    setValue(
      "spanish_formatting_rate",
      item?.translation_rates?.spanish_formatting_rate || ""
    );
    setValue(
      "other_formatting_rate",
      item?.translation_rates?.other_formatting_rate || ""
    );
    setStatus(typeof item?.status == "number" ? item?.status : 1);
    setCredentialsSend(
      typeof item?.user?.credentials_send == "number"
        ? item?.user?.credentials_send
        : 0
    );
    setNotification(
      typeof item?.user?.notifications == "number"
        ? item?.user?.notifications
        : 1
    );
    setInterpretation(
      typeof item?.interpretation == "number"
        ? item?.interpretation
        : 1
    );
    setTranslation(
      typeof item?.translation == "number"
        ? item?.translation
        : 1
    );
    setRequesterDetailsShowInvoice(
      typeof item?.requester_details_show_invoice == "number"
        ? item?.requester_details_show_invoice
        : 1
    );
    setInterpreterNameShowInvoice(
      typeof item?.interpreter_name_show_invoice == "number"
        ? item?.interpreter_name_show_invoice
        : 1
    );

    dispatch(setError({}));

    // Prefill subjects from item.subclient_type_rates
    // if (item?.subclient_type_rates?.length) {
    //   const subjectsFromRates = item.subclient_type_rates.map(rate => rate.subject);
    //   setSubjectBlocks(subjectsFromRates.map((_, index) => index)); // initialize blocks
    //   subjectsFromRates.forEach((subject, index) => {
    //     setValue(`subjects.${index}`, subject);
    //   });
    // } else {
    //   // fallback: first block empty
    //   setSubjectBlocks([0]);
    // }

    // return () => {
    //   resetAllFields();
    // };
  }, [item]);

  useEffect(() => {
    // Existing code...

    // Prefill subjects from item.subclient_type_rates
    if (item?.subclient_type_rates?.length) {
      const rates = item.subclient_type_rates;
      const subjectsFromRates = rates.map(rate => rate.subject);
      setSubjectBlocks(subjectsFromRates.map((_, index) => index)); // initialize blocks
      console.log(rates, 'ratesssss');
      console.log(subjectsFromRates, 'subjectsFromRates');


      subjectsFromRates.forEach((subject, index) => {
        // setValue(`subjects.${index}`, subject);
        setValue(`subjects.${index}`, subject?.toLowerCase() || "");

        // setValue(`subjectConfigs.${index}`, {
        //   client_template_id: rates[index]?.client_template_id || '',
        //   normal_hour_start_time: rates[index]?.normal_hour_start_time || '',
        //   normal_hour_end_time: rates[index]?.normal_hour_end_time || '',
        //   after_hour_start_time: rates[index]?.after_hour_start_time || '',
        //   after_hour_end_time: rates[index]?.after_hour_end_time || '',
        //   grace_period: rates[index]?.grace_period || 0,
        //   incremental: rates[index]?.incremental || '',
        //   rush_fee: rates[index]?.rush_fee || 0,
        // });
        // Set subjectConfigs for each subject individually to avoid overwriting interpretationRates
        const basePath = `subjectConfigs.${index}`;
        setValue(`${basePath}.client_template_id`, rates[index]?.client_template_id || '', { shouldValidate: true });
        setValue(`${basePath}.normal_hour_start_time`, rates[index]?.normal_hour_start_time || '', { shouldValidate: true });
        setValue(`${basePath}.normal_hour_end_time`, rates[index]?.normal_hour_end_time || '', { shouldValidate: true });
        setValue(`${basePath}.after_hour_start_time`, rates[index]?.after_hour_start_time || '', { shouldValidate: true });
        setValue(`${basePath}.after_hour_end_time`, rates[index]?.after_hour_end_time || '', { shouldValidate: true });
        setValue(`${basePath}.grace_period`, rates[index]?.grace_period || 0, { shouldValidate: true });
        setValue(`${basePath}.incremental`, rates[index]?.incremental || '', { shouldValidate: true });
        setValue(`${basePath}.rush_fee`, rates[index]?.rush_fee || 0, { shouldValidate: true });
      });
    } else {
      setSubjectBlocks([0]); // fallback: first block empty
    }

  }, [item]);

  // #region Language dropdown
  useEffect(() => {
    if (item?.preferred_language?.id) {
      setLanguageState({
        label: item?.preferred_language?.name || "",
        value: item?.preferred_language?.id || "",
      });
    } else {
      setLanguageState(null);
    }
    console.log(item, 'item?.preferred_language');
    console.log(languageState, 'setLanguageState');
  }, [item]);

  const filteredLanguagesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchPreferredLanguagesList(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result?.data?.map((language) => ({
        value: language.id,
        label: language.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion


  const generateRandomPassword = (length = 10) => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
    let password = "";
    for (let i = 0; i < length; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  };

  const handleCredentialsToggle = async (e) => {
    const checked = e.target.checked;

    if (checked) {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Are you sure you want to send the credentials?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });

      if (result.isConfirmed) {
        setCredentialsSend(1);
        const randomPwd = generateRandomPassword(10);
        setValue("password", randomPwd, { shouldValidate: true });
      } else {
        setCredentialsSend(0);
        setValue("password", '');
      }
    } else {
      setCredentialsSend(0);
      setValue("password", '');
    }
  };

  const handleSimpleToggle = (e) => {
    setCredentialsSend(e.target.checked ? 1 : 0);
  };

  //#region Dynamic fields
  const handleAdd = React.useCallback(() => {
    const newVariants = [...noOfVariants];
    newVariants.push({
      field: "",
      id: newVariants.length + 1,
      required: false,
      show_in_invoice: false,
    });
    setNoOfVariants(newVariants);
  }, [noOfVariants]);

  const handleRemove = React.useCallback(
    (index) => {
      const newVariants = [...noOfVariants];
      newVariants.splice(index, 1);
      setNoOfVariants(newVariants);
    },
    [noOfVariants]
  );

  const toggleRequired = (index) => {
    const newVariants = [...noOfVariants];
    newVariants[index].required = !newVariants[index].required;
    setNoOfVariants(newVariants);
  };

  const toggleShowInInvoice = (index) => {
    const newVariants = [...noOfVariants];
    newVariants[index].show_in_invoice = !newVariants[index].show_in_invoice;
    setNoOfVariants(newVariants);
  };

  useEffect(() => {
    setValue(
      "dynamic_fields",
      noOfVariants?.map((variant) => variant.field)
    );
    setValue(
      "dynamic_fields_required",
      noOfVariants?.map((variant) => (variant.required ? 1 : 0))
    );
    
    setValue(
      "dynamic_fields_show_in_invoice",
      noOfVariants?.map((variant) => (variant.show_in_invoice ? 1 : 0))
    );
  }, [noOfVariants, setValue]);

  const renderDynamicField = React.useCallback(
    (variant, index) => {
      return (
        <>
          <div
            className="row-primary mb-0 align-items-center mt-2"
            key={variant?.id}
            id={variant?.id}
          >
            <Controller
              name={`dynamic_fields[${index}]`}
              control={control}
              render={({ field }) => (
                <input
                  className="input-in type_inp"
                  type="text"
                  placeholder=""
                  value={variant?.field}
                  onChange={(e) => {
                    const newVariants = [...noOfVariants];
                    newVariants[index].field = e.target.value;
                    setNoOfVariants(newVariants);
                  }}
                />
              )}
            />

            {noOfVariants?.length > 1 && (
              <IconButton color="error" onClick={() => handleRemove(index)}>
                <i className="fa-solid fa-trash-can trash_icon"></i>
              </IconButton>
            )}

            <div className="col-1">
              <h3 className="fst-italic mt-0">Required</h3>
              <Switch
                name={`dynamic_fields_required[${index}]`}
                checked={variant.required}
                onChange={() => toggleRequired(index)}
                color="primary"
              />
            </div>

            <div className="col-1">
              <h3 className="fst-italic mt-0">Show in Invoice</h3>
              <Switch
                name={`dynamic_fields_show_in_invoice[${index}]`}
                checked={variant.show_in_invoice}
                onChange={() => toggleShowInInvoice(index)}
                color="primary"
              />
            </div>

          </div>
        </>
      );
    },
    [noOfVariants, errors]
  );
  //#endregion

  // #region States dropdown

  useEffect(() => {
    dispatch(fetchStates(1, { id: item?.billing_state?.id }));
    if (item?.billing_state?.name && item?.billing_state?.id) {
      setfilterStates({
        label: item?.billing_state?.name || "",
        value: item?.billing_state?.id || "",
      });
    } else {
      setfilterStates(null);
    }
  }, [item?.billing_state]);

  const filteredStatesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchStates(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    setAllStates(result?.data);
    return {
      options: result.data.map((val) => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  // #region City dropdown

  const filteredStates = React.useMemo(() => {
    return states?.map((item) => {
      const object = {
        label: item?.name,
        value: item?.id,
      };
      return object;
    });
  }, [states, item?.billing_state?.name]);

  //#endregion

  // #region Timezone dropdown

  useEffect(() => {
    const fetchAndSetUSA = async () => {
      const result = await dispatch(
        fetchCountries(1, { search: USA }, true, true)
      );
      const countries = result?.data || [];
      const usa = countries.find((c) => c.name === USA);
      if (usa) {
        setfilterCountries({
          label: usa.name,
          value: usa.id,
        });
      }
    };

    fetchAndSetUSA();
  }, []);

  useEffect(() => {
    setFilterTimezones({
      value: item?.timezone?.id,
      label: item?.timezone?.display_name,
    });
  }, [item?.timezone]);

  // Load options function (API call to timezone endpoint)
  const filteredTimezonesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const country_id = filterCountries.value;

    const result = await dispatch(
      fetchTimezone(
        page,
        {
          pageLength: 10,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
          country_id: country_id,
        },
        true,
        true
      )
    );

    return {
      options: result.data.map((val) => ({
        value: val.id,
        label: val.display_name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };

  //#endregion

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      });
      resetAllFields();
      navigate(-1);
    } else {
      console.log("onSubmit", error);
      toast.error(message, {
        className: "errorToast",
      });
    }
  };

  // const onSubmit = (data) => {
  //   dispatch(setError({}));
  //   const newData = {
  //     ...data,
  //     ...data.interpretationRates,
  //     status,
  //     credentialsSend,
  //     notification,
  //   };
  //   delete data.interpretationRates;

  //   if (item?.id) {
  //     if (newData.password === "") {
  //       delete newData.password;
  //     }
  //     dispatch(updateType(newData, item?.id, submitCallback));
  //   } else {
  //     dispatch(addType(newData, submitCallback));
  //   }
  // };

  // const onSubmit = (data) => {
  //   dispatch(setError({}));

  //   const newData = {
  //     ...data,
  //     ...data.interpretationRates,
  //     status,
  //     credentialsSend,
  //     notification,
  //     spanish_translation_rate: Number(data.spanish_translation_rate),
  //     other_translation_rate: Number(data.other_translation_rate),
  //     spanish_formatting_rate: Number(data.spanish_formatting_rate),
  //     other_formatting_rate: Number(data.other_formatting_rate),
  //   };

  //   delete data.interpretationRates;

  //   if (item?.id) {
  //     if (newData.password === "") {
  //       delete newData.password;
  //     }
  //     dispatch(updateType(newData, item?.id, submitCallback));
  //   } else {
  //     dispatch(addType(newData, submitCallback));
  //   }
  // };

  const onSubmit = (data) => {
    if (!interpretation && !translation) {
      toast.error("Please enable at least one service (Interpretation or Translation).", {
        className: "errorToast",
      });
      return;
    }

    dispatch(setError({}));
    const subjects = data.subjects || [];
    // interpretationRates is now scoped inside subjectConfigs, so we don't use data.interpretationRates
    const ratesBySubject = data.interpretationRatesBySubject || [];
    const subjectConfigs = data.subjectConfigs || [];

    const interpretationRates = subjects.map((subject, subjectIndex) => {
      const subjectTiers = ratesBySubject[subjectIndex] || [];
      const config = subjectConfigs[subjectIndex] || {};
      const localRates = config.interpretationRates || {};

      return {
        subject,
        normal_hour_start_time: config.normal_hour_start_time,
        normal_hour_end_time: config.normal_hour_end_time,
        after_hour_start_time: config.after_hour_start_time,
        after_hour_end_time: config.after_hour_end_time,
        grace_period: config.grace_period,
        incremental: config.incremental,
        rush_fee: config.rush_fee,
        client_template_id: config.client_template_id,

        tiers: subjectTiers.map((tier, tierIndex) => ({
          tier_id: tier.tier_id,

          // 🔥 NORMAL HOURS
          opi_normal_rate: localRates.opi_normal_rate?.[tierIndex],
          vri_normal_rate: localRates.vri_normal_rate?.[tierIndex],
          inperson_normal_rate: localRates.inperson_normal_rate?.[tierIndex],

          opi_normal_rate_time_unit: localRates.opi_normal_rate_time_unit?.[tierIndex],
          vri_normal_rate_time_unit: localRates.vri_normal_rate_time_unit?.[tierIndex],
          inperson_normal_time_unit: localRates.inperson_normal_time_unit?.[tierIndex],

          opi_normal_mins: localRates.opi_normal_mins?.[tierIndex],
          vri_normal_mins: localRates.vri_normal_mins?.[tierIndex],
          inperson_normal_mins: localRates.inperson_normal_mins?.[tierIndex],

          opi_normal_mins_time_unit: localRates.opi_normal_mins_time_unit?.[tierIndex],
          vri_normal_mins_time_unit: localRates.vri_normal_mins_time_unit?.[tierIndex],
          inperson_normal_mins_time_unit: localRates.inperson_normal_mins_time_unit?.[tierIndex],

          // 🔥 AFTER HOURS
          opi_after_rate: localRates.opi_after_rate?.[tierIndex],
          vri_after_rate: localRates.vri_after_rate?.[tierIndex],
          inperson_after_rate: localRates.inperson_after_rate?.[tierIndex],

          opi_after_rate_time_unit: localRates.opi_after_rate_time_unit?.[tierIndex],
          vri_after_rate_time_unit: localRates.vri_after_rate_time_unit?.[tierIndex],
          inperson_after_time_unit: localRates.inperson_after_time_unit?.[tierIndex],

          opi_after_mins: localRates.opi_after_mins?.[tierIndex],
          vri_after_mins: localRates.vri_after_mins?.[tierIndex],
          inperson_after_mins: localRates.inperson_after_mins?.[tierIndex],

          opi_after_mins_time_unit: localRates.opi_after_mins_time_unit?.[tierIndex],
          vri_after_mins_time_unit: localRates.vri_after_mins_time_unit?.[tierIndex],
          inperson_after_mins_time_unit: localRates.inperson_after_mins_time_unit?.[tierIndex],
        }))
      };
    }).filter(item => item.subject); // Filter out empty subjects

    const rawCustomTiers = data.subjectCustomTiers || [];
    const subjectCustomTiers = rawCustomTiers.map(subjectTiers => {
      if (!Array.isArray(subjectTiers)) return [];
      return subjectTiers.map(tier => ({
        language_ids: tier.language_ids,
        subject: tier.subject,

        // Normal Rates
        opi_normal_rate: tier.opi_normal_rate ?? 0,
        opi_normal_rate_time_unit: tier.opi_normal_rate_time_unit ?? 'hour',
        opi_normal_mins: tier.opi_normal_mins ?? 0,
        opi_normal_mins_time_unit: tier.opi_normal_mins_time_unit ?? 'minute',

        vri_normal_rate: tier.vri_normal_rate ?? 0,
        vri_normal_rate_time_unit: tier.vri_normal_rate_time_unit ?? 'hour',
        vri_normal_mins: tier.vri_normal_mins ?? 0,
        vri_normal_mins_time_unit: tier.vri_normal_mins_time_unit ?? 'minute',

        inperson_normal_rate: tier.inperson_normal_rate ?? 0,
        inperson_normal_rate_time_unit: tier.inperson_normal_rate_time_unit ?? 'hour',
        inperson_normal_mins: tier.inperson_normal_mins ?? 0,
        inperson_normal_mins_time_unit: tier.inperson_normal_mins_time_unit ?? 'minute',

        // After Rates
        opi_after_rate: tier.opi_after_rate ?? 0,
        opi_after_rate_time_unit: tier.opi_after_rate_time_unit ?? 'hour',
        opi_after_mins: tier.opi_after_mins ?? 0,
        opi_after_mins_time_unit: tier.opi_after_mins_time_unit ?? 'minute',

        vri_after_rate: tier.vri_after_rate ?? 0,
        vri_after_rate_time_unit: tier.vri_after_rate_time_unit ?? 'hour',
        vri_after_mins: tier.vri_after_mins ?? 0,
        vri_after_mins_time_unit: tier.vri_after_mins_time_unit ?? 'minute',

        inperson_after_rate: tier.inperson_after_rate ?? 0,
        inperson_after_rate_time_unit: tier.inperson_after_rate_time_unit ?? 'hour',
        inperson_after_mins: tier.inperson_after_mins ?? 0,
        inperson_after_mins_time_unit: tier.inperson_after_mins_time_unit ?? 'minute',
      }));
    });

    const translationTemplateBlocksData = data.translationTemplateBlocks || [];
    const selected_translation_rates = translationTemplateBlocksData.flatMap((block) =>
      (block.rates || []).map((rate) => ({
        tier_id: rate.tier_id,
        template_id: block.template_id,
        translation_rate: rate.translation_rate ?? 0,
        editing_rate: rate.editing_rate ?? 0,
        dtp_rate: rate.dtp_rate ?? 0,
        review_rate: rate.review_rate ?? 0,
        audio_recording_rate: rate.audio_recording_rate ?? 0,
        transcription_rate: rate.transcription_rate ?? 0,
      }))
    );
    const translation_template_ids = translationTemplateBlocksData
      .map((block) => block.template_id)
      .filter(Boolean);

    const customTranslationTiersData = (data.customTranslationTiers || [])
    .map((tier) => ({
      language_ids: (tier.language_ids || []).map((l) => l?.value ?? l).filter(Boolean),
      translation_rate: tier.translation_rate ?? 0,
      editing_rate: tier.editing_rate ?? 0,
      dtp_rate: tier.dtp_rate ?? 0,
      review_rate: tier.review_rate ?? 0,
      audio_recording_rate: tier.audio_recording_rate ?? 0,
      transcription_rate: tier.transcription_rate ?? 0,
    }))
    .filter((tier) => tier.language_ids.length > 0);

    const newData = {
      ...data,
      interpretationRates,
      subjectCustomTiers,
      credentialsSend: credentialsSend,
      status: status,
      notifications: notification,
      interpretation: interpretation,
      translation: translation,
      requester_details_show_invoice: requesterDetailsShowInvoice,
      interpreter_name_show_invoice: interpreterNameShowInvoice,
      selected_translation_rates,
      translation_template_ids,
      custom_translation_tiers: customTranslationTiersData,
      invoice_group_by: Array.isArray(data.invoice_group_by) ? data.invoice_group_by : [],
      // departments: item?.departments?.map((d) => ({ id: d.id, name: d.name })) || [],
      // sub_accounts: item?.sub_accounts?.map((s) => ({ id: s.id, name: s.name })) || [],
      departments: data.departments || [], 
      // departments: departmentMap,   // [{id: 10, name: "dp 3"}, {id: null, name: "new dept"}]
      sub_accounts: subAccountMap,
    };

    delete newData.interpretationRatesBySubject;
    delete newData.subjectConfigs; // Clean up intermediate data

    if (translation !== 1) {
      delete newData.translation_template_ids;
      delete newData.selected_translation_rates;
    }

    if (item?.id) {
      if (newData.password === "") {
        delete newData.password;
      }
    }

    dispatch(item?.id
      ? updateType(newData, item.id, submitCallback)
      : addType(newData, submitCallback)
    );
  };

  // useEffect mein prefill karo
    useEffect(() => {
      if (item?.departments) {
        setDepartmentMap(item.departments.map(d => ({ id: d.id, name: d.name, billing_email: d.billing_email, contact_person_name : d.contact_person_name, is_communication_poc: d.is_communication_poc, poc_name: d.poc_name, poc_email: d.poc_email, poc_phone: d.poc_phone })));
        setValue("department_names", item.departments.map(d => d.name));
      }
      if (item?.sub_accounts) {
        setSubAccountMap(item.sub_accounts.map(s => ({ id: s.id, name: s.name })));
        setValue("subaccount_names", item.sub_accounts.map(s => s.name));
      }
    }, [item]);




  const selectedSubjects = watch("subjects") || [];

  const getAvailableSubjects = (currentIndex) => {
    const alreadySelectedValues = selectedSubjects
      .filter((val, i) => i !== currentIndex && val) // get stored string values
      .filter(Boolean); // remove empty

    return subjectOptions.filter(
      opt => !alreadySelectedValues.includes(opt.value)
    );
  };



  const subjectOptions = [
    { label: "General", value: "general" },
    { label: "Medical (Non Court)", value: "medical" },
    { label: "Legal", value: "legal" },
    { label: "Court", value: "court" },
  ];

  const translationBlocksWatch = watch("translationTemplateBlocks") || [];
  const hasTranslationTemplateSelected = translationBlocksWatch.some((b) => b?.template_id);

  const invoiceGroupByOptions = [
    { label: "Facility", value: "facility" },
    { label: "Department", value: "department" },
    { label: "Sub Account", value: "sub_account" },
  ];

  return (
    <>
      <FormProvider {...methods}>
        <form className="card_table p-4" onSubmit={handleSubmit(onSubmit)}>
          {/* Main credientials area  */}
          <div className=" template foam_page_row">
            <div className="row-primary">
              <h2>Organization Name *</h2>
              <div className="w-100">
                <Controller
                  name="name"
                  rules={{
                    required: "Organization name is required",
                  }}
                  control={control}
                  render={({ field }) => (
                    <input
                      className="input-in type_inp"
                      type="text"
                      name="name"
                      placeholder="Name"
                      {...field}
                    />
                  )}
                />
                {error?.errors?.name?.map((error) => (
                  <div style={{ marginTop: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
                {errors?.name?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.name?.message} />
                  </div>
                )}
              </div>
            </div>

            <div className="row-primary">
              <h2>Email *</h2>
              <div className="w-100">
                <Controller
                  name="email"
                  rules={{
                    required: "Email is required",
                  }}
                  control={control}
                  render={({ field }) => (
                    <input
                      className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""
                        } `}
                      type="email"
                      autoComplete="off"
                      name="email"
                      pattern={
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                      }
                      placeholder="Email Address"
                      {...field}
                    />
                  )}
                />
                {error?.errors?.email?.map((error) => (
                  <div style={{ marginTop: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
                {errors?.email?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.email?.message} />
                  </div>
                )}
              </div>
            </div>

            <div className="row-primary">
              <h2>
                Password {(!item || credentialsSend === 1) && "*"}
              </h2>
              <div className="w-100">
                <Controller
                  name="password"
                  control={control}
                  rules={{
                    validate: (value) => {
                      if (!item && !value) return "Password is required";
                      if (item && credentialsSend === 1 && !value)
                        return "Password is required";
                      return true;
                    },
                  }}
                  render={({ field }) => (
                    <input
                      className={`input-in type_inp `}
                      autoComplete="new-password"
                      type="password"
                      placeholder="Password"
                      {...field}
                      disabled={watch("type") == "interpreter"}
                    />
                  )}
                />
                {error?.errors?.password?.map((error) => (
                  <div style={{ marginTop: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
                {errors?.password?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.password?.message} />
                  </div>
                )}
              </div>
            </div>

            <div className="row-primary">
              <h2>Phone</h2>
              <div className="w-100">
                <Controller
                  name="phone"
                  control={control}
                  render={({ field }) => (
                    <PhoneInput
                      className={`input-in type_inp ${error?.errors?.phone ? "border-red" : ""
                        } `}
                      type="tel"
                      name="contact"
                      placeholder="Phone number"
                      {...field}
                    />
                  )}
                />
                {error?.errors?.phone?.map((error) => (
                  <div style={{ marginTop: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
              </div>
            </div>

            <div className="row-primary">
              <h2>Timezone*</h2>
              <Controller
                name="timezone_id"
                control={control}
                rules={{ required: "Please select a Timezone" }}
                render={({ field }) => (
                  <div style={{ width: "100%" }}>
                    <AsyncPaginate
                      styles={selectCustomStyles}
                      value={filterTimezones}
                      loadOptions={filteredTimezonesLoadOptions}
                      isClearable
                      placeholder="Select Timezone"
                      onChange={(selected) => {
                        setFilterTimezones(selected);
                        setValue("timezone_id", selected?.value || "");
                        field.onChange(selected?.value || "");
                      }}
                      additional={{ page: 1 }}
                    />
                    {errors?.timezone_id?.message && (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors?.timezone_id?.message} />
                      </div>
                    )}
                  </div>
                )}
              />
            </div>

            <div className="row-primary">
              <h2>Invoicing Period *</h2>
              <div className="w-100">
                <Controller
                  name="invoicing_period"
                  rules={{
                    required: "Please select one",
                  }}
                  control={control}
                  render={({ field }) => (
                    <div className="select_box" style={{ width: "100%" }}>
                      <Select
                        name="invoicing_period"
                        options={invoiceOption || []}
                        value={
                          field.value
                            ? invoiceOption?.find(
                              (opt) => field.value == opt.value
                            )
                            : ""
                        }
                        isClearable={false}
                        disabledSearch={true}
                        onChange={(value) => {
                          field.onChange(value);
                        }}
                      />
                    </div>
                  )}
                />
                {errors?.invoicing_period?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.invoicing_period?.message} />
                  </div>
                )}
              </div>
            </div>

            <div className="row-primary"></div>
            <div className="row-primary align-items-center template_switch">
              <h2 className="m-0">Credentials will be sent over email</h2>
              <label className="custom-checkbox checkbox">
                <input
                  type="checkbox"
                  name="credentials_send"
                  checked={credentialsSend === 1 ? true : false}
                  onChange={item ? handleCredentialsToggle : handleSimpleToggle}
                />
                <span className="checkmark"></span>
              </label>
            </div>

            <div className="row-primary align-items-center template_switch">
              <h2 className="mt-0">
                Notifications{" "}
                <span className="opacity-50">
                  (all type of notification regarding appointments)
                </span>
              </h2>
              <CustomSwitch
                labelText="notifications"
                checked={notification == 1 ? true : false}
                handleChange={(checked) => setNotification(checked ? 1 : 0)}
              />
            </div>
            <div className="row-primary align-items-center template_switch">
              <div className="d-flex flex-wrap justify-content-between align-items-center w-100">
                <div className="row-primary align-items-center template_switch w-auto">
                  <h2 className="mt-0">
                    Interpretation
                  </h2>
                  <CustomSwitch
                    labelText="interpretation"
                    checked={interpretation == 1 ? true : false}
                    handleChange={(checked) => setInterpretation(checked ? 1 : 0)}
                  />
                </div>

                <div className="row-primary align-items-center template_switch w-auto">
                  <h2 className="mt-0">
                    Translation
                  </h2>
                  <CustomSwitch
                    labelText="translation"
                    checked={translation == 1 ? true : false}
                    handleChange={(checked) => setTranslation(checked ? 1 : 0)}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* facilities tag input */}
          <DynamicFacilities item={item} />

          {/* department tag input */}

          <DynamicDepartments item={item} />

          {/* <div className="row-primary">
            <h2>Departments</h2>
            <Controller
              name="department_names"
              control={control}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <TagInput
                    value={field.value}
                    onEditTag={(tag) => {
                      const entity = departmentMap.find((d) => d.name === tag);
                      if (entity) setPendingDepartmentEdit(entity);
                    }}
                    onChange={(newNames) => {
                      field.onChange(newNames);
                      const mapped = mapTagNamesToEntities(
                        newNames,
                        departmentMap,
                        pendingDepartmentEdit
                      );
                      if (
                        pendingDepartmentEdit &&
                        mapped.some(
                          (item) =>
                            item.id === pendingDepartmentEdit.id &&
                            item.name !== pendingDepartmentEdit.name
                        )
                      ) {
                        setPendingDepartmentEdit(null);
                      }
                      setDepartmentMap(mapped);
                    }}
                  />
                </div>
              )}
            />
          </div> */}
          {/* subaccount tag input */}
          <div className="row-primary">
            <h2>Sub account</h2>
            {/* <Controller
              name="subaccount_names"
              control={control}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <TagInput
                    value={field.value}
                    onChange={(obj) => {
                      field.onChange(obj);
                    }}
                  />
                </div>
              )}
            /> */}
            <Controller
              name="subaccount_names"
              control={control}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <TagInput
                    value={field.value}
                    onEditTag={(tag) => {
                      const entity = subAccountMap.find((s) => s.name === tag);
                      if (entity) setPendingSubAccountEdit(entity);
                    }}
                    onChange={(newNames) => {
                      field.onChange(newNames);
                      const mapped = mapTagNamesToEntities(
                        newNames,
                        subAccountMap,
                        pendingSubAccountEdit
                      );
                      if (
                        pendingSubAccountEdit &&
                        mapped.some(
                          (item) =>
                            item.id === pendingSubAccountEdit.id &&
                            item.name !== pendingSubAccountEdit.name
                        )
                      ) {
                        setPendingSubAccountEdit(null);
                      }
                      setSubAccountMap(mapped);
                    }}
                  />
                </div>
              )}
            />
          </div>

          <FilterSwitch
            setLockStates={setLockStates}
            item={item}
            setValue={setValue}
            lockStates={lockStates}
            control={control}
            interpretation={interpretation}
            translation={translation}
          />

          <hr />
          {/* Notification Preferences section */}
          <div className="w-100 biling_info mt-4">
            <div className="row-primary row-r justify-content-between flex-row">
              <h2 className="fst-italic">Invoice Setting</h2>
            </div>

            <div className=" template foam_page_row">

              <div className="row-primary align-items-center template_switch">
                <h2 className="mt-0">
                  Requester details
                </h2>
                <CustomSwitch
                  labelText="requester_details_show_invoice"
                  checked={requesterDetailsShowInvoice == 1 ? true : false}
                  handleChange={(checked) => setRequesterDetailsShowInvoice(checked ? 1 : 0)}
                />
              </div>

              <div className="row-primary align-items-center template_switch">
                <h2 className="mt-0">
                  Interpreter Name
                </h2>
                <CustomSwitch
                  labelText="interpreter_name_show_invoice"
                  checked={interpreterNameShowInvoice == 1 ? true : false}
                  handleChange={(checked) => setInterpreterNameShowInvoice(checked ? 1 : 0)}
                />
              </div>

            </div>

            <div className="row-primary">
              <h2>Group Invoice By</h2>
              <div className="w-100">
                <Controller
                  name="invoice_group_by"
                  control={control}
                  render={({ field }) => (
                    <div className="select_box" style={{ width: "100%" }}>
                      <ReactSelect
                        styles={selectCustomStyles}
                        name="invoice_group_by"
                        options={invoiceGroupByOptions || []}
                        isMulti
                        isClearable
                        menuPlacement="auto"
                        value={
                          Array.isArray(field.value)
                            ? invoiceGroupByOptions.filter((opt) => field.value.includes(opt.value))
                            : []
                        }
                        onChange={(selected) => {
                          const values = Array.isArray(selected) ? selected.map((s) => s.value) : [];
                          field.onChange(values);
                        }}
                      />
                    </div>
                  )}
                />
              </div>
            </div>

          </div>
          <hr />
          {/* Notification Preferences section */}
          <div className="w-100 biling_info mt-4">
            <div className="row-primary row-r justify-content-between flex-row">
              <h2 className="fst-italic">Notification Preferences</h2>
            </div>
            <div className="template foam_page_row">
              <div className="row-primary">
                <h2>Preferred Language *</h2>
                <div className="w-100">
                  <Controller
                    name="preferred_language_id"
                    control={control}
                    rules={{ required: "Preferred language is required" }}
                    render={({ field }) => (
                      <div style={{ width: "100%" }}>
                        <AsyncPaginate
                          menuPlacement="auto"
                          styles={{
                            ...selectCustomStyles,
                          }}
                          value={languageState}
                          loadOptions={filteredLanguagesLoadOptions}
                          isClearable
                          escapeClearsValue
                          onChange={(selected) => {
                            // setLanguageState(selected);
                            setLanguageState(selected || null);
                            setValue("preferred_language_id", selected?.value || "");
                            field.onChange(selected?.value || "");
                          }}
                          placeholder="Select Language"
                          additional={{
                            page: 1,
                          }}
                        />
                        {errors?.preferred_language_id?.message && (
                          <div style={{ marginBottom: 10 }}>
                            <ErrorMessage text={errors?.preferred_language_id?.message} />
                          </div>
                        )}
                      </div>
                    )}
                  />
                </div>
              </div>

              <div className="row-primary">
                <h2>Notification Emails</h2>
                <div className="w-100">
                  <Controller
                    name="notification_emails"
                    control={control}
                    render={({ field }) => (
                      <TagInput
                        value={Array.isArray(field.value) ? field.value : (field.value ? field.value.split(',').map(e => e.trim()) : [])}
                        placeholder="Enter email addresses and press Enter"
                        onChange={(tags) => {
                          field.onChange(tags.join(','));
                        }}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>

          <hr />
          {/* Billing info area  */}
          <div className="w-100 biling_info">
            <div className="row-primary row-r justify-content-between flex-row">
              <h2 className="fst-italic">Biling information </h2>
            </div>
            <div className="template foam_page_row">
              <div className="row-primary">
                <h2>Email *</h2>
                <div className="w-100">
                  <Controller
                    name="billing_email"
                    control={control}
                    rules={{
                      required: "Billing email is required",
                    }}
                    render={({ field }) => (
                      <input
                        className={`input-in type_inp ${error?.errors?.billing_email ? "border-red" : ""
                          } `}
                        type="email"
                        autoComplete="off"
                        name="billing_email"
                        pattern={
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                        }
                        placeholder="Email Address"
                        {...field}
                      />
                    )}
                  />
                  {errors?.billing_email?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.billing_email?.message} />
                    </div>
                  )}
                </div>
              </div>

              <div className="row-primary">
                <h2>Contact Person Name</h2>
                <div className="w-100">
                  <Controller
                    name="billing_person"
                    control={control}
                    render={({ field }) => (
                      <input
                        className="input-in type_inp"
                        type="text"
                        name="billing_person"
                        placeholder="Name"
                        {...field}
                      />
                    )}
                  />
                </div>
              </div>

              <div className="row-primary">
                <h2>Select State *</h2>

                <Controller
                  name="billing_state_id"
                  control={control}
                  rules={{
                    required: "Please select a state",
                  }}
                  render={({ field }) => (
                    <div style={{ width: "100%" }}>
                      <AsyncPaginate
                        menuPlacement="auto"
                        styles={{
                          ...selectCustomStyles,
                        }}
                        value={filterStates}
                        loadOptions={filteredStatesLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(obj) => {
                          setfilterStates(obj);

                          field.onChange(obj?.value);
                        }}
                        additional={{
                          page: 1,
                        }}
                      />
                      {errors?.billing_state_id?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage
                            text={errors?.billing_state_id?.message}
                          />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>

              <div className="row-primary">
                <h2>City Name *</h2>
                <Controller
                  name="billing_city_name"
                  control={control}
                  rules={{
                    required: "City Name is required",
                  }}
                  render={({ field }) => (
                    <div className="w-100">
                      <input
                        className="input-in type_inp"
                        type="text"
                        name="billing_city_name"
                        placeholder="Enter City Name"
                        {...field}
                      />
                      {errors?.billing_city_name?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage
                            text={errors?.billing_city_name?.message}
                          />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>

              <div className="row-primary">
                <h2>Zip Code *</h2>
                <div className="w-100">
                  <Controller
                    name="billing_zipcode"
                    rules={{
                      required: "Zip Code is required",
                    }}
                    control={control}
                    render={({ field }) => (
                      <input
                        className="input-in type_inp"
                        type="text"
                        name="billing_zipcode"
                        placeholder="Zip Code"
                        {...field}
                      />
                    )}
                  />
                  {errors?.billing_zipcode?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.billing_zipcode?.message} />
                    </div>
                  )}

                  {error?.errors?.billing_zipcode?.map((error) => (
                    <div style={{ marginTop: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                </div>
              </div>

              <div className="row-primary">
                <h2>Phone</h2>
                <div className="w-100">
                  <Controller
                    name="billing_phone"
                    control={control}
                    render={({ field }) => (
                      <PhoneInput
                        className={`input-in type_inp ${error?.errors?.billing_phone ? "border-red" : ""
                          } `}
                        type="tel"
                        name="contact"
                        placeholder="Phone number"
                        {...field}
                      />
                    )}
                  />
                  {error?.errors?.billing_phone?.map((error) => (
                    <div style={{ marginTop: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>


          {/* {interpretation == 1 && (
          <hr />
          )} */}
          {/* Dynamic fields  */}
          <div className="w-100 dynamic_fields">
            <hr />
            <div className="row-primary row-r justify-content-between flex-row">
              <h2>Dynamic Fields </h2>
              <SubmitButton
                btnText="Add"
                buttonType="button"
                handleSubmit={handleAdd}
              />
            </div>
            {noOfVariants?.map((variant, index) =>
              renderDynamicField(variant, index)
            )}
            {interpretation == 1 && (
            <hr />
            )}
          </div>

          {interpretation == 1 && subjectBlocks.map((block, index) => {
            const currentSubject = watch(`subjects.${index}`);

            return (
              <div key={index}>

                <div className="row-primary align-items-center">
                  <h2 className="m-0">Subject *</h2>
                  <Controller
                    name={`subjects.${index}`}
                    control={control}
                    rules={{ required: "Please select a subject" }}
                    render={({ field }) => {
                      const selectedOption = subjectOptions.find(
                        // opt => opt.value === field.value
                        opt => opt.value === field.value?.toString().toLowerCase()
                      );
                      return (
                        <Select
                          styles={selectCustomStyles}
                          placeholder="Select Subject"
                          options={getAvailableSubjects(index)}
                          value={selectedOption || null}
                          isClearable={false}
                          // onChange={(selected) => field.onChange(selected)}
                          onChange={(selected) => {
                            const basePath = `subjectConfigs.${index}.interpretationRates`;
                            const rateFields = [
                                'opi_normal_rate', 'vri_normal_rate', 'inperson_normal_rate',
                                'opi_normal_rate_time_unit', 'vri_normal_rate_time_unit', 'inperson_normal_time_unit',
                                'opi_normal_mins', 'vri_normal_mins', 'inperson_normal_mins',
                                'opi_normal_mins_time_unit', 'vri_normal_mins_time_unit', 'inperson_normal_mins_time_unit',
                                'opi_after_rate', 'vri_after_rate', 'inperson_after_rate',
                                'opi_after_rate_time_unit', 'vri_after_rate_time_unit', 'inperson_after_time_unit',
                                'opi_after_mins', 'vri_after_mins', 'inperson_after_mins',
                                'opi_after_mins_time_unit', 'vri_after_mins_time_unit', 'inperson_after_mins_time_unit',
                            ];
                            rateFields.forEach(f => setValue(`${basePath}.${f}`, ''));

                            setValue(`subjectConfigs.${index}.client_template_id`, '');
                            setValue(`subjectConfigs.${index}.normal_hour_start_time`, '');
                            setValue(`subjectConfigs.${index}.normal_hour_end_time`, '');
                            setValue(`subjectConfigs.${index}.after_hour_start_time`, '');
                            setValue(`subjectConfigs.${index}.after_hour_end_time`, '');
                            setValue(`subjectConfigs.${index}.grace_period`, 0);
                            setValue(`subjectConfigs.${index}.incremental`, '');
                            setValue(`subjectConfigs.${index}.rush_fee`, 0);

                            setValue(`interpretationRatesBySubject.${index}`, []);

                            setValue(`subjectCustomTiers.${index}`, []);

                            field.onChange(selected);
                        }}
                        // onChange={(selected) => field.onChange(selected?.value)}
                        />
                      );
                    }}
                  />

                  {errors?.subjects?.[index]?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.subjects?.[index]?.message} />
                    </div>
                  )}
                  {subjectBlocks.length > 1 && (
                    <IconButton color="error" onClick={() => handleRemoveSubject(index)}>
                      <i className="fa-solid fa-trash-can trash_icon"></i>
                    </IconButton>
                  )}
                </div>

                {currentSubject && (
                  <>
                    <LanguageTiers
                      key={`language-tier-${index}-${currentSubject?.value || currentSubject}`}
                      subjectIndex={index}
                      subject={currentSubject}
                      sendClientData={handleClientData}
                      control={control}
                      error={error}
                      errors={errors}
                      item={item}
                      dispatch={dispatch}
                      setValue={setValue}
                      watch={watch}
                      deletedSubjects={deletedSubjects}
                    />

                    <CustomTiers
                      subjectIndex={index}
                      control={control}
                      error={error}
                      errors={errors}
                      item={item}
                      dispatch={dispatch}
                      setValue={setValue}
                      watch={watch}
                      Controller={Controller}
                      unregister={unregister}
                      deletedSubjects={deletedSubjects}
                    />

                    {index === subjectBlocks.length - 1 && (
                      <div className="d-flex justify-content-center">
                        <SubmitButton
                          btnText="Add More"
                          buttonType="button"
                          handleSubmit={() => setSubjectBlocks(prev => {
                            const newIndex = prev.length;
                            setValue(`subjects.${newIndex}`, ""); // initialize new subject field
                            return [...prev, newIndex];
                          })}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            );
          })}

          {/* <LanguageTiers
            sendClientData={handleClientData}
            control={control}
            error={error}
            errors={errors}
            item={item}
            dispatch={dispatch}
            setValue={setValue}
            watch={watch}
          />

          <CustomTiers
            control={control}
            error={error}
            errors={errors}
            item={item}
            dispatch={dispatch}
            setValue={setValue}
            watch={watch}
            Controller={Controller}
            unregister={unregister}
          /> */}

          <hr />
          {/* Translation Rates  */}
          {translation == 1 && (
          <>
          <h2 className="text-center my-3 fw-bold fst-italic">
            Translation Rates
          </h2>
          <div
            className="row-primary"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
              marginTop: 20,
              marginBottom: 50,
            }}
          >
          <TranslationTiersPreview item={item} />
          <CustomTranslationTiers item={item} hasTemplateSelected={hasTranslationTemplateSelected} />
          </div>
          </>)}

          <div className="Form-footer footer_fullpage">
            <div className="row-primary m-0 align-items-center  template_switch">
              {checkPermission("Status Client Account") && (
                <>
                  <h2 className="mt-0">Status</h2>
                  <CustomSwitch
                    labelText="active"
                    checked={status == 1 ? true : false}
                    handleChange={(checked) => setStatus(checked ? 1 : 0)}
                  />
                </>
              )}
            </div>

            <SubmitButton
              loader={loader}
              btnText={item?.id ? "Update" : "Create"}
            />
          </div>
        </form>
      </FormProvider >

      {loader && <FullPageLoader />
      }
    </>
  );
};

export default AccountForm;
